import { Card, Switch, Text } from "@ttc3k/trekker";
import { cva, RecipeVariantProps } from "styled-system/css";
import { Flex, styled } from "styled-system/jsx";

const cardSurfaceStyles = cva({
  base: { bg: "white" },
  variants: {
    visual: {
      default: {},
      error: {
        borderColor: "border.error",
        color: "text.error.mid",
      },
    },
  },
  defaultVariants: {
    visual: "default",
  },
});

const CardSurface = styled(Card.Surface, cardSurfaceStyles);

type CardSurfaceProps = NonNullable<
  RecipeVariantProps<typeof cardSurfaceStyles>
>;

type SwitchCardProps = CardSurfaceProps & {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  title: string;
  subtitle?: string;
  /** Show the whole subtitle instead of clamping it to two lines. */
  wrapSubtitle?: boolean;
  disabled?: boolean;
};

export const SwitchCard = ({
  checked,
  onCheckedChange,
  title,
  visual,
  subtitle = "",
  wrapSubtitle = false,
  disabled = false,
}: SwitchCardProps) => {
  return (
    <CardSurface visual={visual}>
      <Card.Body>
        <Card.BodyContent alignItems={"center"}>
          {subtitle && wrapSubtitle ? (
            <Flex flexDir={"column"} gap={"50"} flex={"1"} minW={"0"}>
              <Text visual={"bodySemiBold"} data-maintext>
                {title}
              </Text>
              <Text visual={"smallRegular"} color={"text.light"}>
                {subtitle}
              </Text>
            </Flex>
          ) : subtitle ? (
            <Card.Title mainText={title} subText={subtitle} />
          ) : (
            <Text visual={"bodySemiBold"} lineClamp={2} data-maintext>
              {title}
            </Text>
          )}
          <Switch
            checked={checked}
            onCheckedChange={e => onCheckedChange?.(e.checked)}
            disabled={disabled}
          />
        </Card.BodyContent>
      </Card.Body>
    </CardSurface>
  );
};
